var news = "https://shopfront-cdn.tekoapis.com/static/3a4cd6f50be1dbbb.svg";

export { news as default };
